/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_MenuInputs */

const en_for_whom_tag_menu = /** @type {(inputs: For_Whom_Tag_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meal plan`)
};

const pl_for_whom_tag_menu = /** @type {(inputs: For_Whom_Tag_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadłospis`)
};

/**
* | output |
* | --- |
* | "Meal plan" |
*
* @param {For_Whom_Tag_MenuInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_menu = /** @type {((inputs?: For_Whom_Tag_MenuInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_MenuInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_menu(inputs)
	return en_for_whom_tag_menu(inputs)
});